import type { Theme} from '@mui/material/styles';
import type { Css, Cx, CSSObject } from 'tss-react/types';

import createCache from '@emotion/cache';
import { useTheme } from '@mui/material/styles';
import { createMakeAndWithStyles, keyframes } from 'tss-react';

const tssCache = createCache({
    key: 'tss-custom'
});

tssCache.compat = true; // disabled SSR-Warnings

export const { makeStyles } = createMakeAndWithStyles({
    useTheme,
    cache: tssCache
});

/** short callback to produce string like here: https://docs.tss-react.dev/page-1/keyframes */
export function getKeyframes(
    code: string,
    additionalParameters: string = '',
): string {
    return `${keyframes`${code}`} ${additionalParameters}`;
}

export type StyleRules<ClassNames extends string = string> = Record<ClassNames, CSSObject>;

interface MakeStylesResult<ClassNames extends string = string> {
    classes: Record<ClassNames, string>;
    theme: Theme;
    css: Css;
    cx: Cx;
}

export type MakeStylesHook<ClassNames extends string = string, ParametersType = void> =
    (ParametersType extends {} ?
        (parameters: ParametersType) => MakeStylesResult<ClassNames> :
        () => MakeStylesResult<ClassNames>
    );